"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaginationActions = void 0;
/**
 * Copyright © 2019 - Present, VamStar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
const React = __importStar(require("react"));
const lab_1 = require("@mui/lab");
const styles_1 = require("@mui/styles");
const useStyles = styles_1.makeStyles((theme) => styles_1.createStyles({
    root: {
        flexShrink: 0,
        marginLeft: theme.spacing(2),
    },
}));
/**
 * On the pagination action these events get triggered.
 * OnChange event gets passed to the higher component
 * @param props TablePaginationActionsProps from material UI
 * @returns JSX
 */
exports.PaginationActions = (props) => {
    const { count, page, onPageChange, rowsPerPage } = props;
    const classes = useStyles();
    return (React.createElement("div", { className: classes.root },
        React.createElement(lab_1.Pagination, { shape: "rounded", color: "primary", page: page + 1, count: Math.ceil(count / rowsPerPage), onChange: (_e, pageNumber) => onPageChange(_e, pageNumber) })));
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUGFnaW5hdGlvbkFjdGlvbnMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9wYWdpbmF0aW9uL1BhZ2luYXRpb25BY3Rpb25zLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUE7Ozs7OztHQU1HO0FBQ0gsNkNBQStCO0FBQy9CLGtDQUFzQztBQUN0Qyx3Q0FBdUQ7QUFJdkQsTUFBTSxTQUFTLEdBQUcsbUJBQVUsQ0FBQyxDQUFDLEtBQVksRUFBRSxFQUFFLENBQzVDLHFCQUFZLENBQUM7SUFDWCxJQUFJLEVBQUU7UUFDSixVQUFVLEVBQUUsQ0FBQztRQUNiLFVBQVUsRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQztLQUM3QjtDQUNGLENBQUMsQ0FDSCxDQUFDO0FBRUY7Ozs7O0dBS0c7QUFDVSxRQUFBLGlCQUFpQixHQUFHLENBQUMsS0FBa0MsRUFBRSxFQUFFO0lBQ3RFLE1BQU0sRUFBRSxLQUFLLEVBQUUsSUFBSSxFQUFFLFlBQVksRUFBRSxXQUFXLEVBQUUsR0FBRyxLQUFLLENBQUM7SUFDekQsTUFBTSxPQUFPLEdBQUcsU0FBUyxFQUFFLENBQUM7SUFFNUIsT0FBTyxDQUNMLDZCQUFLLFNBQVMsRUFBRSxPQUFPLENBQUMsSUFBSTtRQUMxQixvQkFBQyxnQkFBVSxJQUNULEtBQUssRUFBQyxTQUFTLEVBQ2YsS0FBSyxFQUFDLFNBQVMsRUFDZixJQUFJLEVBQUUsSUFBSSxHQUFHLENBQUMsRUFDZCxLQUFLLEVBQUUsSUFBSSxDQUFDLElBQUksQ0FBQyxLQUFLLEdBQUcsV0FBVyxDQUFDLEVBQ3JDLFFBQVEsRUFBRSxDQUFDLEVBQUUsRUFBRSxVQUFVLEVBQUUsRUFBRSxDQUFDLFlBQVksQ0FBQyxFQUFxRCxFQUFFLFVBQVUsQ0FBQyxHQUM3RyxDQUNFLENBQ1AsQ0FBQztBQUNKLENBQUMsQ0FBQyJ9